import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { CheckInChart } from "../../../../merchant/merchant/home/components/Statistics/StatisticsPieChartCheckIns"
import { useSupplier } from "../../../../supplier/supplierHooks"
import { CompanyReportsHomeQuery, fetchCheckInSummary } from "../companyReportsHomeApi"

export function CheckInStat({ periodInDays }: { periodInDays: number }) {
    const { supplierId } = useSupplier()

    const { data } = useApiQuery(fetchCheckInSummary, {
        queryName: CompanyReportsHomeQuery.CHECK_IN_SUMMARY,
        dependencies: {
            companyId: supplierId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })

    if (!data) return null

    return <CheckInChart summary={data.checkInSummary} />
}
